import { render, staticRenderFns } from "./AddProducts.vue?vue&type=template&id=d64d90a2&scoped=true"
import script from "./AddProducts.vue?vue&type=script&lang=js"
export * from "./AddProducts.vue?vue&type=script&lang=js"
import style0 from "./AddProducts.vue?vue&type=style&index=0&id=d64d90a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64d90a2",
  null
  
)

export default component.exports